/** Los kodu promocyjnego zwracany w odpowiedzi quote. */
export enum PromoCodeStatus {
  /** Rabat naliczony — widoczny w appliedDiscounts. */
  APPLIED = 'APPLIED',
  /** Kod przyjęty, rabat naliczy się po uzupełnieniu danych formularza. */
  DEFERRED = 'DEFERRED',
  /** Kod nieznany, nieważny, po limicie użyć albo bez zastosowania. */
  NOT_APPLIED = 'NOT_APPLIED',
}
